import {
	CerrarSesion,
	Nav,
	NavGroup,
	NavItem,
	NavTitle,
	Spacer,
} from "../LeftMenu";
import { Users } from "@/assets/icons/Icons";

export function MainAdminMenu() {
	return (
		<Nav>
			<NavTitle>Gestor Huella de Carbono</NavTitle>
			<NavGroup>
				<NavItem
					title="Empresas"
					description="Visualiza las empresas dadas de alta en la plataforma."
					url="/admin/"
					icon={Users}
				/>
			</NavGroup>

			<Spacer />

			<CerrarSesion />
		</Nav>
	);
}
